
export const APPLICATION = 'SfygLandingApp';

export const APPLICATION_VERSION = '1';

export const AUTH_SERVER_BASE_URL = 'https://sphygmobp.com';

export const SERVER_DOMAIN: string|undefined = 'OxEp'; // hashid
